import { useQuery } from '@tanstack/react-query';
import { tradesKeys } from '@/services/query-keys/trades-keys';
import { tradesService } from '@/services/trades/trades-service';

/**
 * Fetch the full holidays list and cache for an hour. Callers filter
 * locally by date, avoiding per-keystroke API hits on date inputs.
 *
 * 1h is a compromise between back-end load and freshness: ops can edit the
 * holiday calendar in admin and operators will see the change within an
 * hour without a hard SPA reload.
 */
export const useHolidays = (enabled = true) => {
  return useQuery({
    queryKey: tradesKeys.holidays(),
    queryFn: () => tradesService.getHolidays(),
    enabled,
    staleTime: 60 * 60 * 1000,
  });
};
